import './App.css';
import Photos from './components/Photos/Photos';
import 'bootstrap/dist/css/bootstrap.min.css';
import sai from "./images1/sairaminstitutions.jpg";
import founder from "./images1/founder.png";
import Contact from './rules';
import video from "./video.mp4";


function App() {
  return (
    <>
      <section class="rio">
        <nav class="navbar" >
          <div class="container-fluid">
            <img className="logo" src={sai}></img>;
            <form class="d-flex" role="search">

              {/* <a href="https://airtable.com/shrqiM1yf9ydAyaSz" class="btn btn-primary active me-5" aria-current="page">School Registration</a>
              <a href="https://airtable.com/shrXCd8gfUuwl0GQ4" class="btn btn-primary active" aria-current="page">Event Registration</a> */}
            </form>
          </div>
        </nav>

        <section class="sec1">
          <div class="bk">
            <div class="leo">
              <img src={founder} style={{ height: "100px", width: "100px", marginLeft: "95px", marginTop: "50px" }}></img>
              <div>

                <br />
                <h2 class="wrt1">
                  <div class="ab"> <b>SAITECH S2T 3.0</b></div>
                  <div class="bc">09-02-2023 (THURSDAY) </div>
                </h2>
                <h5 class="cd">The main objective of this program is to bring out the talents & innovative skills of school children both at rural and urban level</h5>
                <br />
                <h2 class="meo">Registration's are closed.Thank you for your interest.</h2>
                <br />

                {/* <a href="https://airtable.com/shrqiM1yf9ydAyaSz" class="btn btn-primary active" id="bt1" aria-current="page">School Registration</a><br />
                <br /> <a href="https://airtable.com/shrXCd8gfUuwl0GQ4" class="btn btn-primary active" id="bt2" aria-current="page">Event Registration</a> */}
              </div>
            </div>

          </div>

        </section>
        <div>
          <section class="sec2">

            <div class="ate">
              <h4 class="ate1">ABOUT THE EVENT</h4>
              <h3 class="wrt2">Schools Towards Technology is a flagship event of Sairam Institutions towards achieving the goals of SDG among school children in the State of TamilNadu.</h3>
              <div className='flex-container'>
                <div className='flex-1'>
                  <p><b>
                    <center><h3>List of Events:</h3></center>
                    1.Junior Scientist<br />
                    2.Young Scientist<br />
                    3.SDG Treasure Hunt<br />
                    4.Robo Competition<br />
                    5.Photography Contest aligned with SDG<br />
                    6.Innovative Drone Challenge<br />
                  </b>
                  </p>
                  <p class="dates">
                    <b>
                      Deadlines:<br />
                      School registration - 29-01-2023<br />
                      Event registration  - 01-02-2023<br />
                      Venue:<br />
                      Shri Leo Muthu Indoor Stadium<br />
                      Sairam Institutions

                    </b>
                  </p>
                </div>
                <div className='flex-2'>
                <center>
                <h3>Promo</h3>
                
                 <video className="video" src={video} type="video/mp4" width={500} height={300} controls></video>
                </center>

                </div>

              </div>





            </div>



          </section>
        </div><br/>

        <div className='con'>
          <Contact></Contact>
          <Photos></Photos>

        </div>

      </section >


    </>


  );
}


export default App;


